import type { TFunction, TOptions } from 'i18next';
import { LANGUAGES } from '@/modules/localization';
import { Locale } from './languages';

export function translationFactory(
  key: string | string[],
  options: {
    params?: TOptions;
    format?: (value: string) => string;
  } = {}
) {
  return (t: TFunction) => {
    const trans = t(key, options.params);

    return options.format ? options.format(trans) : trans;
  };
}

export function detectTranslation(
  key: ((t: TFunction) => string) | string,
  t: TFunction
) {
  return typeof key === 'function' ? key(t) : key;
}

export const isMatchLanguage = (userCountry: string, systemLang: string) => {
  if (LANGUAGES[userCountry] == null) {
    return true;
  }

  return LANGUAGES[userCountry].some(({ locale }) => locale === systemLang);
};

export const getLanguageByCountry = (userCountry: string): Locale =>
  LANGUAGES[userCountry]?.[0].locale || Locale.ENGLISH;
